export enum IcpFit {
  UNKNOWN = 1,
  NO_FIT,
  POTENTIAL_FIT,
  GOOD_FIT
}

// Which record an ICP fit score describes. Only the Unknown tooltip copy varies
// by subject; GENERIC is wording true of either, for callers with no entity type
// to hand in (the shared table cell renderer). The values are the trailing
// segment of the icpFit.unknownTooltip.* translation keys.
export enum IcpFitSubject {
  COMPANY = "company",
  PERSON = "person",
  GENERIC = "generic"
}

export type IcpFitDetailBulletStatus = "pass" | "fail" | "not_assessed";

export interface IcpFitDetailBullet {
  status: IcpFitDetailBulletStatus;
  primary: string;
  secondary?: string;
}

// Server-side `icpMetadata` payload backing the ICP-fit Details popover.
export interface IcpMetadata {
  bullets?: IcpFitDetailBullet[];
}
